import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { Form, Offcanvas } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { DOCUMENT_TYPE_LABELS } from '../utils/Constants'
import useAxiosRequests from '../hooks/useAxiosRequest'
import ExternalRoutes from '../config/ExternalRoutes'
import { Formik } from 'formik'
import { useNavigate } from 'react-router'
import { registerLocale } from 'react-datepicker'
import fr from 'date-fns/locale/fr'
import { safeDate } from '../utils/FormatDate';

registerLocale('fr', fr)

export const Filter = ({ show, onClose }) => {
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [docType, setDocType] = useState('')
  const [docStatus, setDocStatus] = useState([])
  const [status, setStatus] = useState('')
  const { sendRequest } = useAxiosRequests()
  const navigate = useNavigate()

  const fetchData = async () => {
    try {
      const response = await sendRequest({
        method: 'GET',
        url: ExternalRoutes.status.list
      })
      setDocStatus(response.member)
    } catch (error) {
    }
  }

  useEffect(() => {
    if (show) {
      fetchData()
    }
  }, [show])

  const handleFilter = () => {
    const safeStartDate =
      startDate instanceof Date ? startDate.toISOString() : null;
    const safeEndDate = safeDate(endDate);

    navigate('/chest-of-documents', {
      state: {
        startDate: safeStartDate,
        endDate: safeEndDate,
        docType: docType,
        status: status
      }
    });
    onClose();
    setStartDate('');
    setEndDate('');
    setDocType('');
    setStatus('');
  }


  const getNextDay = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    date.setDate(date.getDate() + 1);
    return date.toISOString().split('T')[0];
  };


  const resetForm = async () => {
    setStartDate('');
    setEndDate('');
    setDocType('');
    setStatus('');
  }

  return (
    <Offcanvas
      className='kl-offcanvas'
      show={show}
      onHide={onClose}
      placement='end'
    >
      <Offcanvas.Header>
        <button onClick={onClose} className='p-0 kl-back-button'>
          <FontAwesomeIcon icon={faArrowLeft} className='kl-icon-arrow' />
        </button>
        <Offcanvas.Title>Filtres</Offcanvas.Title>
        <button className='kl-button-reset-filter' onClick={resetForm}>reset</button>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Formik initialValues={{}} onSubmit={handleFilter}>
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            errors,
            touched,
            isValid,
            isSubmitting,
          }) => (
            <form
              noValidate
              autoComplete='off'
              className=''
              onSubmit={handleSubmit}
            >
              <div>
                <div className='kl-input-filter'>
                  <Form.Label>Periode</Form.Label>
                  <div className='kl-input-date'>
                    <div
                      className='kl-input-container mb-4'
                      style={{ cursor: 'pointer' }}
                    >
                      <div className='kl-fa-icon' style={{ zIndex: 2 }}>
                        <svg
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M6.66699 4.29175C6.63684 4.29175 6.60556 4.27946 6.57992 4.25382C6.55428 4.22818 6.54199 4.1969 6.54199 4.16675V1.66675C6.54199 1.6366 6.55428 1.60532 6.57992 1.57968C6.60556 1.55403 6.63684 1.54175 6.66699 1.54175C6.69714 1.54175 6.72842 1.55403 6.75406 1.57968C6.77971 1.60532 6.79199 1.6366 6.79199 1.66675V4.16675C6.79199 4.1969 6.77971 4.22818 6.75406 4.25382C6.72842 4.27946 6.69714 4.29175 6.66699 4.29175Z'
                            fill='#292D32'
                            stroke='#9CA3AF'
                          />
                          <path
                            d='M13.333 4.29175C13.3029 4.29175 13.2716 4.27946 13.2459 4.25382C13.2203 4.22818 13.208 4.1969 13.208 4.16675V1.66675C13.208 1.6366 13.2203 1.60532 13.2459 1.57968C13.2716 1.55403 13.3029 1.54175 13.333 1.54175C13.3632 1.54175 13.3944 1.55403 13.4201 1.57968C13.4457 1.60532 13.458 1.6366 13.458 1.66675V4.16675C13.458 4.1969 13.4457 4.22818 13.4201 4.25382C13.3944 4.27946 13.3632 4.29175 13.333 4.29175Z'
                            fill='#292D32'
                            stroke='#9CA3AF'
                          />
                          <path
                            d='M7.08333 12.0834C6.975 12.0834 6.86667 12.0584 6.76667 12.0168C6.65833 11.9751 6.575 11.9168 6.49167 11.8418C6.34167 11.6834 6.25 11.4751 6.25 11.2501C6.25 11.1418 6.275 11.0334 6.31667 10.9334C6.35833 10.8334 6.41667 10.7418 6.49167 10.6584C6.575 10.5834 6.65833 10.5251 6.76667 10.4834C7.06667 10.3584 7.44167 10.4251 7.675 10.6584C7.825 10.8168 7.91667 11.0334 7.91667 11.2501C7.91667 11.3001 7.90833 11.3584 7.9 11.4168C7.89167 11.4668 7.875 11.5168 7.85 11.5668C7.83333 11.6168 7.80833 11.6668 7.775 11.7168C7.75 11.7584 7.70833 11.8001 7.675 11.8418C7.51667 11.9918 7.3 12.0834 7.08333 12.0834Z'
                            fill='#292D32'
                          />
                          <path
                            d='M10.0003 12.0832C9.89199 12.0832 9.78366 12.0582 9.68366 12.0166C9.57532 11.9749 9.49199 11.9166 9.40866 11.8416C9.25866 11.6832 9.16699 11.4749 9.16699 11.2499C9.16699 11.1416 9.19199 11.0332 9.23366 10.9332C9.27533 10.8332 9.33366 10.7416 9.40866 10.6582C9.49199 10.5832 9.57532 10.5249 9.68366 10.4832C9.98366 10.3499 10.3587 10.4249 10.592 10.6582C10.742 10.8166 10.8337 11.0332 10.8337 11.2499C10.8337 11.2999 10.8253 11.3582 10.817 11.4166C10.8087 11.4666 10.792 11.5166 10.767 11.5666C10.7503 11.6166 10.7253 11.6666 10.692 11.7166C10.667 11.7582 10.6253 11.7999 10.592 11.8416C10.4337 11.9916 10.217 12.0832 10.0003 12.0832Z'
                            fill='#292D32'
                          />
                          <path
                            d='M12.9163 12.0832C12.808 12.0832 12.6997 12.0582 12.5997 12.0166C12.4913 11.9749 12.408 11.9166 12.3247 11.8416C12.2913 11.7999 12.258 11.7582 12.2247 11.7166C12.1913 11.6666 12.1663 11.6166 12.1497 11.5666C12.1247 11.5166 12.108 11.4666 12.0997 11.4166C12.0913 11.3582 12.083 11.2999 12.083 11.2499C12.083 11.0332 12.1747 10.8166 12.3247 10.6582C12.408 10.5832 12.4913 10.5249 12.5997 10.4832C12.908 10.3499 13.2747 10.4249 13.508 10.6582C13.658 10.8166 13.7497 11.0332 13.7497 11.2499C13.7497 11.2999 13.7413 11.3582 13.733 11.4166C13.7247 11.4666 13.708 11.5166 13.683 11.5666C13.6663 11.6166 13.6413 11.6666 13.608 11.7166C13.583 11.7582 13.5413 11.7999 13.508 11.8416C13.3497 11.9916 13.133 12.0832 12.9163 12.0832Z'
                            fill='#292D32'
                          />
                          <path
                            d='M7.08333 15C6.975 15 6.86667 14.975 6.76667 14.9333C6.66667 14.8917 6.575 14.8333 6.49167 14.7583C6.34167 14.6 6.25 14.3833 6.25 14.1667C6.25 14.0583 6.275 13.95 6.31667 13.85C6.35833 13.7417 6.41667 13.65 6.49167 13.575C6.8 13.2667 7.36667 13.2667 7.675 13.575C7.825 13.7333 7.91667 13.95 7.91667 14.1667C7.91667 14.3833 7.825 14.6 7.675 14.7583C7.51667 14.9083 7.3 15 7.08333 15Z'
                            fill='#292D32'
                          />
                          <path
                            d='M10.0003 15C9.78366 15 9.56699 14.9083 9.40866 14.7583C9.25866 14.6 9.16699 14.3833 9.16699 14.1667C9.16699 14.0583 9.19199 13.95 9.23366 13.85C9.27533 13.7417 9.33366 13.65 9.40866 13.575C9.71699 13.2667 10.2837 13.2667 10.592 13.575C10.667 13.65 10.7253 13.7417 10.767 13.85C10.8087 13.95 10.8337 14.0583 10.8337 14.1667C10.8337 14.3833 10.742 14.6 10.592 14.7583C10.4337 14.9083 10.217 15 10.0003 15Z'
                            fill='#292D32'
                          />
                          <path
                            d='M12.9163 14.9999C12.6997 14.9999 12.483 14.9083 12.3247 14.7583C12.2497 14.6833 12.1913 14.5916 12.1497 14.4833C12.108 14.3833 12.083 14.2749 12.083 14.1666C12.083 14.0583 12.108 13.9499 12.1497 13.8499C12.1913 13.7416 12.2497 13.6499 12.3247 13.5749C12.5163 13.3833 12.808 13.2916 13.0747 13.3499C13.133 13.3583 13.183 13.3749 13.233 13.3999C13.283 13.4166 13.333 13.4416 13.383 13.4749C13.4247 13.4999 13.4663 13.5416 13.508 13.5749C13.658 13.7333 13.7497 13.9499 13.7497 14.1666C13.7497 14.3833 13.658 14.5999 13.508 14.7583C13.3497 14.9083 13.133 14.9999 12.9163 14.9999Z'
                            fill='#292D32'
                          />
                          <path
                            d='M17.0837 8.19995H2.91699C2.57533 8.19995 2.29199 7.91662 2.29199 7.57495C2.29199 7.23328 2.57533 6.94995 2.91699 6.94995H17.0837C17.4253 6.94995 17.7087 7.23328 17.7087 7.57495C17.7087 7.91662 17.4253 8.19995 17.0837 8.19995Z'
                            fill='#292D32'
                          />
                          <path
                            d='M13.3333 18.9584H6.66667C3.625 18.9584 1.875 17.2084 1.875 14.1667V7.08341C1.875 4.04175 3.625 2.29175 6.66667 2.29175H13.3333C16.375 2.29175 18.125 4.04175 18.125 7.08341V14.1667C18.125 17.2084 16.375 18.9584 13.3333 18.9584ZM6.66667 3.54175C4.28333 3.54175 3.125 4.70008 3.125 7.08341V14.1667C3.125 16.5501 4.28333 17.7084 6.66667 17.7084H13.3333C15.7167 17.7084 16.875 16.5501 16.875 14.1667V7.08341C16.875 4.70008 15.7167 3.54175 13.3333 3.54175H6.66667Z'
                            fill='#292D32'
                          />
                        </svg>
                      </div>
                      <DatePicker
                        selected={startDate}
                        onChange={date => setStartDate(date)}
                        dateFormat='dd MMMM yyyy'
                        locale='fr'
                        className='kl-input-login kl-input-datetime-filter'
                        popperClassName="datepicker-start-popper"
                        placeholderText='date de début'
                      />
                    </div>
                    <div
                      className='kl-input-container mb-4'
                      style={{ position: 'relative' }}
                    >
                      <div className='kl-fa-icon' style={{ zIndex: 2 }}>
                        <svg
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M6.66699 4.29175C6.63684 4.29175 6.60556 4.27946 6.57992 4.25382C6.55428 4.22818 6.54199 4.1969 6.54199 4.16675V1.66675C6.54199 1.6366 6.55428 1.60532 6.57992 1.57968C6.60556 1.55403 6.63684 1.54175 6.66699 1.54175C6.69714 1.54175 6.72842 1.55403 6.75406 1.57968C6.77971 1.60532 6.79199 1.6366 6.79199 1.66675V4.16675C6.79199 4.1969 6.77971 4.22818 6.75406 4.25382C6.72842 4.27946 6.69714 4.29175 6.66699 4.29175Z'
                            fill='#292D32'
                            stroke='#9CA3AF'
                          />
                          <path
                            d='M13.333 4.29175C13.3029 4.29175 13.2716 4.27946 13.2459 4.25382C13.2203 4.22818 13.208 4.1969 13.208 4.16675V1.66675C13.208 1.6366 13.2203 1.60532 13.2459 1.57968C13.2716 1.55403 13.3029 1.54175 13.333 1.54175C13.3632 1.54175 13.3944 1.55403 13.4201 1.57968C13.4457 1.60532 13.458 1.6366 13.458 1.66675V4.16675C13.458 4.1969 13.4457 4.22818 13.4201 4.25382C13.3944 4.27946 13.3632 4.29175 13.333 4.29175Z'
                            fill='#292D32'
                            stroke='#9CA3AF'
                          />
                          <path
                            d='M7.08333 12.0834C6.975 12.0834 6.86667 12.0584 6.76667 12.0168C6.65833 11.9751 6.575 11.9168 6.49167 11.8418C6.34167 11.6834 6.25 11.4751 6.25 11.2501C6.25 11.1418 6.275 11.0334 6.31667 10.9334C6.35833 10.8334 6.41667 10.7418 6.49167 10.6584C6.575 10.5834 6.65833 10.5251 6.76667 10.4834C7.06667 10.3584 7.44167 10.4251 7.675 10.6584C7.825 10.8168 7.91667 11.0334 7.91667 11.2501C7.91667 11.3001 7.90833 11.3584 7.9 11.4168C7.89167 11.4668 7.875 11.5168 7.85 11.5668C7.83333 11.6168 7.80833 11.6668 7.775 11.7168C7.75 11.7584 7.70833 11.8001 7.675 11.8418C7.51667 11.9918 7.3 12.0834 7.08333 12.0834Z'
                            fill='#292D32'
                          />
                          <path
                            d='M10.0003 12.0832C9.89199 12.0832 9.78366 12.0582 9.68366 12.0166C9.57532 11.9749 9.49199 11.9166 9.40866 11.8416C9.25866 11.6832 9.16699 11.4749 9.16699 11.2499C9.16699 11.1416 9.19199 11.0332 9.23366 10.9332C9.27533 10.8332 9.33366 10.7416 9.40866 10.6582C9.49199 10.5832 9.57532 10.5249 9.68366 10.4832C9.98366 10.3499 10.3587 10.4249 10.592 10.6582C10.742 10.8166 10.8337 11.0332 10.8337 11.2499C10.8337 11.2999 10.8253 11.3582 10.817 11.4166C10.8087 11.4666 10.792 11.5166 10.767 11.5666C10.7503 11.6166 10.7253 11.6666 10.692 11.7166C10.667 11.7582 10.6253 11.7999 10.592 11.8416C10.4337 11.9916 10.217 12.0832 10.0003 12.0832Z'
                            fill='#292D32'
                          />
                          <path
                            d='M12.9163 12.0832C12.808 12.0832 12.6997 12.0582 12.5997 12.0166C12.4913 11.9749 12.408 11.9166 12.3247 11.8416C12.2913 11.7999 12.258 11.7582 12.2247 11.7166C12.1913 11.6666 12.1663 11.6166 12.1497 11.5666C12.1247 11.5166 12.108 11.4666 12.0997 11.4166C12.0913 11.3582 12.083 11.2999 12.083 11.2499C12.083 11.0332 12.1747 10.8166 12.3247 10.6582C12.408 10.5832 12.4913 10.5249 12.5997 10.4832C12.908 10.3499 13.2747 10.4249 13.508 10.6582C13.658 10.8166 13.7497 11.0332 13.7497 11.2499C13.7497 11.2999 13.7413 11.3582 13.733 11.4166C13.7247 11.4666 13.708 11.5166 13.683 11.5666C13.6663 11.6166 13.6413 11.6666 13.608 11.7166C13.583 11.7582 13.5413 11.7999 13.508 11.8416C13.3497 11.9916 13.133 12.0832 12.9163 12.0832Z'
                            fill='#292D32'
                          />
                          <path
                            d='M7.08333 15C6.975 15 6.86667 14.975 6.76667 14.9333C6.66667 14.8917 6.575 14.8333 6.49167 14.7583C6.34167 14.6 6.25 14.3833 6.25 14.1667C6.25 14.0583 6.275 13.95 6.31667 13.85C6.35833 13.7417 6.41667 13.65 6.49167 13.575C6.8 13.2667 7.36667 13.2667 7.675 13.575C7.825 13.7333 7.91667 13.95 7.91667 14.1667C7.91667 14.3833 7.825 14.6 7.675 14.7583C7.51667 14.9083 7.3 15 7.08333 15Z'
                            fill='#292D32'
                          />
                          <path
                            d='M10.0003 15C9.78366 15 9.56699 14.9083 9.40866 14.7583C9.25866 14.6 9.16699 14.3833 9.16699 14.1667C9.16699 14.0583 9.19199 13.95 9.23366 13.85C9.27533 13.7417 9.33366 13.65 9.40866 13.575C9.71699 13.2667 10.2837 13.2667 10.592 13.575C10.667 13.65 10.7253 13.7417 10.767 13.85C10.8087 13.95 10.8337 14.0583 10.8337 14.1667C10.8337 14.3833 10.742 14.6 10.592 14.7583C10.4337 14.9083 10.217 15 10.0003 15Z'
                            fill='#292D32'
                          />
                          <path
                            d='M12.9163 14.9999C12.6997 14.9999 12.483 14.9083 12.3247 14.7583C12.2497 14.6833 12.1913 14.5916 12.1497 14.4833C12.108 14.3833 12.083 14.2749 12.083 14.1666C12.083 14.0583 12.108 13.9499 12.1497 13.8499C12.1913 13.7416 12.2497 13.6499 12.3247 13.5749C12.5163 13.3833 12.808 13.2916 13.0747 13.3499C13.133 13.3583 13.183 13.3749 13.233 13.3999C13.283 13.4166 13.333 13.4416 13.383 13.4749C13.4247 13.4999 13.4663 13.5416 13.508 13.5749C13.658 13.7333 13.7497 13.9499 13.7497 14.1666C13.7497 14.3833 13.658 14.5999 13.508 14.7583C13.3497 14.9083 13.133 14.9999 12.9163 14.9999Z'
                            fill='#292D32'
                          />
                          <path
                            d='M17.0837 8.19995H2.91699C2.57533 8.19995 2.29199 7.91662 2.29199 7.57495C2.29199 7.23328 2.57533 6.94995 2.91699 6.94995H17.0837C17.4253 6.94995 17.7087 7.23328 17.7087 7.57495C17.7087 7.91662 17.4253 8.19995 17.0837 8.19995Z'
                            fill='#292D32'
                          />
                          <path
                            d='M13.3333 18.9584H6.66667C3.625 18.9584 1.875 17.2084 1.875 14.1667V7.08341C1.875 4.04175 3.625 2.29175 6.66667 2.29175H13.3333C16.375 2.29175 18.125 4.04175 18.125 7.08341V14.1667C18.125 17.2084 16.375 18.9584 13.3333 18.9584ZM6.66667 3.54175C4.28333 3.54175 3.125 4.70008 3.125 7.08341V14.1667C3.125 16.5501 4.28333 17.7084 6.66667 17.7084H13.3333C15.7167 17.7084 16.875 16.5501 16.875 14.1667V7.08341C16.875 4.70008 15.7167 3.54175 13.3333 3.54175H6.66667Z'
                            fill='#292D32'
                          />
                        </svg>
                      </div>
                      <div>
                        <DatePicker
                          selected={endDate}
                          onChange={date => setEndDate(date)}
                          dateFormat='dd MMMM yyyy'
                          locale='fr'
                          className='kl-input-login kl-input-datetime-filter'
                          popperClassName="datepicker-end-popper"
                          placeholderText='date de fin'
                          minDate={getNextDay(startDate)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='kl-input-filter'>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={status}
                    onChange={e => setStatus(e.target.value)}
                    aria-label='Tous'
                    className='kl-input-select'
                  >
                    <option value=''>Tous</option>
                    {docStatus.map((status, index) => {
                      return (
                        <option value={status?.docStName} key={index}>
                          {status?.docStName}
                        </option>
                      )
                    })}
                  </Form.Select>
                </div>
                <div className='kl-input-filter'>
                  <Form.Label>Type</Form.Label>
                  <Form.Select
                    value={docType}
                    onChange={e => setDocType(e.target.value)}
                    aria-label='Tous'
                    className='kl-input-select'
                  >
                    <option value=''>Tous</option>
                    {Object.entries(DOCUMENT_TYPE_LABELS).map(
                      ([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      )
                    )}
                  </Form.Select>
                </div>
                <div className='kl-input-filter'>
                  <Form.Label>catégorie</Form.Label>
                  <Form.Select aria-label='Tous' className='kl-input-select'>
                    <option>Tous</option>
                  </Form.Select>
                </div>
              </div>
              <div>
                <button
                  type='submint'
                  className='btn btn-primary kl-button-filter'
                  variant={isValid ? 'primary' : 'secondary'}
                  size='lg'
                  disabled={!isValid || isSubmitting}
                >
                  {isSubmitting ? 'Traitement en cours...' : 'Filtrer'}
                </button>
              </div>
            </form>
          )}
        </Formik>
      </Offcanvas.Body>
    </Offcanvas>
  )
}
